import React from 'react';
import * as Icons from './icons';

export const RenderIcon = ({iconName}) => {
    const Icon = Icons[iconName];

    return (
        <Icon />
    )
}
